const validateRequestorIATA = (IATANumber) => !!(IATANumber
    && IATANumber.length !== 8);

export default validateRequestorIATA;
